import endpoints from '../../modules/ajio-util/endpoints';
import {
  getErrorStatusCode,
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler
} from '../../modules/ajio-fetch/utils';
import { showError } from './HTTPError';
import fetcher from '../../modules/ajio-fetch';

function fetchURL(req) {
  const param = req.params.cid ? req.params.cid : 'newin';
  let apiPath = `${endpoints.get('capsulenewin')}?pageId=/capsule/${encodeURIComponent(
    param
  )}&fields=BASIC&format=json`;

  if (req.device.type == 'desktop') {
    apiPath = `${endpoints.get('capsulenewin')}?pageId=/capsule/${encodeURIComponent(
      param
    )}&fields=BASIC&format=json&uiel=Desktop`;
  }

  if (req.params.category) {
    if (req.device.type == 'desktop') {
      apiPath = `${endpoints.get('capsulenewin')}?pageId=/capsule/${encodeURIComponent(param)}/${
        req.params.category
      }&fields=BASIC&format=json&uiel=Desktop`;
    } else {
      apiPath = `${endpoints.get('capsulenewin')}?pageId=/capsule/${encodeURIComponent(param)}/${
        req.params.category
      }&fields=BASIC&format=json`;
    }
  }
  return fetcher(apiPath, fetchGetJSONReqOpts());
}

function getCapsuleDetailsResponse(capsules) {
  return {
    type: 'FETCH_CAPSULE_DATA_SUCCESS',
    capsules
  };
}

export function getAllCapsuleDetails(req) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      return fetchURL(req)
        .then(fetchGetJSONResHandler)
        .then(json => {
          const { capsules = [] } = json;
          const activeSlideItem = capsules[0] || {};
          const { id: activeSlide, imageURL: activeImage, title: activeTitle } = activeSlideItem;
          json = { ...json, activeSlide, activeImage, activeTitle };
          dispatch(getCapsuleDetailsResponse(json));
          resolve(json);
        })
        .catch(err => {
          const statusCode = getErrorStatusCode(err);
          dispatch(showError('home', statusCode));
          reject(err);
        });
    });
  };
}

export function setActiveSlide(name, imageURL, title) {
  return {
    type: 'SET_ACTIVE_CAPSULE_ID',
    activeCapsuleName: name,
    activeCapsuleImage: imageURL,
    activeCapsuleTitle: title
  };
}
